import { GretaAIChatRowStatus } from '../../GretaAIChat.constants'
import { getIsGretaAIChatChatRunning } from '../../GretaAIChat.utils'

export function setGretaAIChatRowStatus({ chatId, status, statusById }) {
  return { ...statusById, [chatId]: status }
}

export function getGretaAIChatMergedRowStatusById(chatStatusById, chats) {
  return chats.reduce((merged, chat) => {
    if (!(chat.id in merged) && getIsGretaAIChatChatRunning(chat)) {
      return { ...merged, [chat.id]: GretaAIChatRowStatus.Generating }
    }

    return merged
  }, chatStatusById)
}
